import * as policyEvents from "./policyEventsConstants";
import {DefaultPolicy} from "./DefaultPolicy";
import {getRoles, getPatronRole, getPatronSubType} from "../../Utilities/LocalStorage/storageUtilities";

interface AllowProps {
    children?: React.ReactNode;
    policyEvent?: string;
    roles?: (number | undefined)[];
    patronRole?: number | undefined;
    patronSubType?: number | undefined;
}

export const allow = (policyEvent = policyEvents.VIEW, roles = getRoles()): boolean => {
    return Allow({policyEvent: policyEvent, roles: roles}) as boolean;
};

export const Allow = ({children, policyEvent = policyEvents.VIEW, roles = getRoles(), patronRole = getPatronRole(), patronSubType = getPatronSubType()}: AllowProps): React.ReactNode | boolean => {

    const policy = new DefaultPolicy(roles, patronRole, patronSubType);
    const isAllowed = policy.permit(policyEvent);

    if (!children)
        return isAllowed;

    if (isAllowed)
        return children;

    return null;
};
